import React, { useEffect, useState, useRef } from 'react'
import { FormattedMessage } from 'react-intl'
import { useStyles } from './CompanyShowcase_style'
import { Box, Chip, Container } from '@material-ui/core'
import Typography from '@material-ui/core/Typography'
import HomeAPI from 'api/HomeAPI'
import HorizontalCardsSlider from 'components/HorizontalCardsSlider/HorizontalCardsSlider'
import CompanyCard from 'cards/CompanyCard/CompanyCard'
import ProgressCircle from 'components/ProgressCircle/ProgressCircle'
import Paper from 'components/Paper/Paper'
import Button from 'components/Button/Button'
import RouteMapLink from 'wrappers/RouteMapLink/RouteMapLink'

const CompanyShowcase = () => {
    const classes = useStyles()
    const [showcaseCompanies, setShowcaseCompanies] = useState([])
    const [filter, setFilter] = useState('popular')
    const [companyCount, setCompanyCount] = useState(0)
    const sliderRef = useRef()

    useEffect(() => {
        HomeAPI.GetShowcaseCompanies().then((response) => {
            setShowcaseCompanies(response.data.showcase_companies)
            setCompanyCount(response.data.company_count)
        })
    }, [])

    const slideToStart = () => {
        sliderRef.current.scrollLeft -= 9999
    }

    const handleFilterChange = (value) => {
        slideToStart()
        setFilter(value)
    }

    const renderChip = (value) => {
        return (
            <Chip
                className={`${classes.chip} ${filter === value && classes.active}`}
                classes={{ root: classes.chipRoot, label: classes.chipLabel }}
                style={{ backgroundColor: 'var(--background-grey-light)' }}
                label={<FormattedMessage id={`company_showcase.filter.${value}`}/>}
                key={`school-index-chip-${value}`}
                color='var(--foreground-grey-dark)'
                onClick={() => handleFilterChange(value)}
            />
        )
    }

    return (
        <Box className={classes.companyFilterContainer}>
            <Box className={classes.companyFilterText}>
                <Typography
                    component='h2'
                    color='primary'
                    className={classes.companyFilterTitle}
                >
                    <FormattedMessage id='company_showcase.title' />
                </Typography>
                <Typography
                    component='p'
                    color='primary'
                    className={classes.companyFilterDescription}
                >
                    <FormattedMessage id='company_showcase.description' />
                </Typography>
            </Box>
            <Paper className={classes.paper}>
                {renderChip('popular')}
                {renderChip('start_up')}
                {renderChip('impact')}
                {renderChip('marketing')}
                {renderChip('consulting')}
            </Paper>
            <Container disableGutters maxWidth='lg' className={classes.sliderContainer}>
                {showcaseCompanies[filter]
                    ? <HorizontalCardsSlider
                        key='HorizontalCardsSlider-company-showcase'
                        wrappedArrows
                        shift={500}
                        parentSliderRef={sliderRef}
                    >
                        {showcaseCompanies[filter].map((company) => {
                            return (
                                <Box key={`company-filter-${company.name}`} className={classes.companyFilterBox}>
                                    <CompanyCard company={company}/>
                                </Box>
                            )
                        })}
                    </HorizontalCardsSlider>
                    : <ProgressCircle/>
                }
            </Container>
            {companyCount &&
                <RouteMapLink page='companies'>
                    <Button>
                        <FormattedMessage id='company_showcase.button' values={{ count: companyCount }} />
                    </Button>
                </RouteMapLink>
            }
        </Box>
    )
}
export default CompanyShowcase
